import api from "../API/api";

export interface ReviewRequest {
  spId: string;
  rating: number;
  comment: string;
}

export interface Review {
  id: string;
  userId: string;
  userName: string;
  userImage: string;
  spId: string;
  rating: number;
  comment: string;
  createdAt: string;
}

// Post a review
export const postReview = (reviewData: ReviewRequest) => {
  return (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithToken(`userapi/reviews`, reviewData)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.error("Error posting review:", err);
          reject(err);
        });
    });
  };
};

// Get review by ID
export const getReviewById = (reviewId: string) => {
  return (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      return api
        .getwithToken(`userapi/reviews/${reviewId}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.error("Error getting review:", err);
          reject(err);
        });
    });
  };
};

// Get all reviews for a specific service provider with pagination
export const getReviewsBySpId = (spId: string, pageNo: number = 1, pageSize: number = 20) => {
  return (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      return api
        .getwithToken(`userapi/reviews/sp/${spId}?page-no=${pageNo}&page-size=${pageSize}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.error("Error getting reviews:", err);
          reject(err);
        });
    });
  };
};

// Get reviews for a specific service provider to check if user already reviewed
export const getUserReviewForSp = (spId: string) => {
  return (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      return api
        .getwithToken(`userapi/reviews/sp/${spId}`)
        .then((res) => {
          // Since this returns all reviews, we need to find the current user's review
          // We'll filter this in the component based on the logged-in user ID
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

// Update an existing review
export const updateReview = (reviewId: string, reviewData: ReviewRequest) => {
  return (dispatch: any) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`userapi/reviews/${reviewId}`, reviewData)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};